import { formatDuration, modalityName, type GameSummaryPayload } from '@bingo/shared';

/**
 * Resumo da partida ocupando o telão inteiro.
 *
 * Serve a dois momentos com o MESMO desenho, de propósito: o fim de uma
 * partida e a consulta a uma partida antiga pelo histórico. Quem está no
 * salão reconhece a tela na hora, e não existe "o resumo de verdade" e "o
 * resumo do histórico" — é um só.
 */
export function SummaryOverlay({
  summary,
  eventName,
  startedAt,
  /** "Revendo" aparece quando é uma partida do histórico, não a que acabou. */
  revisiting = false,
}: {
  summary: GameSummaryPayload;
  eventName: string;
  startedAt?: string;
  revisiting?: boolean;
}) {
  return (
    <div className="summary-overlay">
      <header>
        <p className="summary-kicker">
          {revisiting ? 'Revendo' : 'Fim da'} partida {summary.gameNumber}
          {revisiting && startedAt
            ? ` · ${new Date(startedAt).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })}`
            : ''}
        </p>
        <h2>{eventName}</h2>
      </header>

      <div className="summary-totals">
        <div>
          <span>Tempo total</span>
          <strong>{formatDuration(summary.totalMs)}</strong>
        </div>
        <div>
          <span>Soma das rodadas</span>
          <strong>{formatDuration(summary.roundsMs)}</strong>
        </div>
        <div>
          <span>Rodadas jogadas</span>
          <strong>{summary.roundsCount}</strong>
        </div>
      </div>

      <table className="summary-table">
        <thead>
          <tr>
            <th>Rodada</th>
            <th>Valendo</th>
            <th>Bolas</th>
            <th>Tempo</th>
            <th>Ganhadores</th>
          </tr>
        </thead>
        <tbody>
          {summary.rounds.map((round) => (
            <tr key={round.number}>
              <td>{round.number}</td>
              <td>{modalityName(round.modality)}</td>
              <td>
                {round.ballsCount}
                {round.carriedCount > 0 ? <small> ({round.carriedCount} herdadas)</small> : null}
              </td>
              <td>{formatDuration(round.durationMs)}</td>
              <td>
                {round.winners.length === 0
                  ? '—'
                  : round.winners.map((winner) => winner.name).join(', ')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
